import type {
  ExistingMaterialQuery,
  MaterialTableQuery,
  StoreMaterialTableQuery
} from 'pages/material/models';

import type {
  Material,
  MaterialAtStoreToAdd,
  MaterialAtStoreToMove,
  MaterialPriceOperation,
  MaterialToAdd,
  MaterialToEdit,
  Store,
  StoreDetail,
  TableResultExistingMaterial,
  TableResultMaterial
} from './models/mainservice';
import type { StoreDetailV2, StoreToAddV2, StoreV2 } from './models/unified';
import { protectedApiClient } from './support/baseApiClients';

export default {
  addMaterial: async (data: MaterialToAdd) => {
    const result = await protectedApiClient.post<Material>(`/Material`, data);
    return result.data;
  },
  deleteMaterial: async (materialId: string) => {
    const result = await protectedApiClient.delete<undefined>(`/Material/${materialId}`);
    return result.data;
  },
  editMaterial: async (params: { materialId: string; data: MaterialToEdit }) => {
    const result = await protectedApiClient.put<undefined>(
      `/Material/${params.materialId}`,
      params.data
    );
    return result.data;
  },
  getMaterial: async (params: MaterialTableQuery) => {
    const result = await protectedApiClient.get<TableResultMaterial>(`/Material`, { params });
    return result.data;
  },
  getStoredMaterial: () => {
    return protectedApiClient.get<Material[]>(`/Material/GetStoredMaterial`);
  },
  addMaterialToStore: async (params: { data: MaterialAtStoreToAdd[]; storeId: string }) => {
    const result = await protectedApiClient.post<undefined>(
      `/Material/Store/${params.storeId}/AddToStore`,
      params.data
    );
    return result.data;
  },
  addStoreV2: async (data: StoreToAddV2) => {
    const result = await protectedApiClient.post<StoreV2>(`/Material/Store/v2`, data);
    return result.data;
  },
  editStoreV2: async (params: { storeId: string; values: StoreToAddV2 }) => {
    const result = await protectedApiClient.put<StoreV2>(
      `/Material/Store/v2/${params.storeId}`,
      params.values
    );
    return result.data;
  },
  getStoreDetail: async (storeId: string, params: StoreMaterialTableQuery) => {
    const result = await protectedApiClient.get<StoreDetail>(`/Material/Store/${storeId}`, {
      params
    });
    return result.data;
  },
  getStoreDetailv2: async (storeId: string, params: StoreMaterialTableQuery) => {
    const result = await protectedApiClient.get<StoreDetailV2>(`/Material/Store/v2/${storeId}`, {
      params
    });
    return result.data;
  },
  getStores: async () => {
    const result = await protectedApiClient.get<Store[]>(`/Material/Store`);
    return result.data;
  },
  getStoresV2: async () => {
    const result = await protectedApiClient.get<StoreV2[]>(`/Material/Store/v2`);
    return result.data;
  },
  moveToStore: async (params: {
    data: MaterialAtStoreToMove[];
    storeId: string;
    moveToId: string;
  }) => {
    const result = await protectedApiClient.put<undefined>(
      `/Material/Store/${params.storeId}/MoveTo/${params.moveToId}`,
      params.data
    );

    return result.data;
  },
  removeFromStore: async (params: { storeId: string; data: MaterialAtStoreToMove[] }) => {
    const result = await protectedApiClient.put<undefined>(
      `/Material/Store/${params.storeId}/RemoveMaterial`,
      params.data
    );
    return result.data;
  },
  deleteStore: async (storeId: string) => {
    const result = await protectedApiClient.delete<undefined>(`/material/store/${storeId}`);
    return result.data;
  },
  searchForExisting: async (params: ExistingMaterialQuery) => {
    const result = await protectedApiClient.get<TableResultExistingMaterial>(
      '/material/searchForExisting/v2',
      {
        params
      }
    );

    return result.data;
  },
  changePrice: async (data: MaterialPriceOperation) => {
    const result = await protectedApiClient.put<undefined>(`/Material/priceChange`, data);
    return result.data;
  },
  getMaterialDetail: async (materialId: string) => {
    const result = await protectedApiClient.get<Material>(`/Material/${materialId}`);
    return result.data;
  }
};
